import ComicCard from '@/components/base/ComicCard';
import { recommendedComics } from '@/mocks/comics';

export default function RecommendedSection() {
  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="mb-8">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            编辑推荐
          </h2>
          <p className="text-sm text-foreground-500 mt-1">
            编辑部精选的高分韩国漫画
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {recommendedComics.map((comic) => (
            <div
              key={comic.id}
              className="group flex gap-4 p-4 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer"
              onClick={() => window.REACT_APP_NAVIGATE(`/comic/${comic.id}`)}
            >
              {/* Cover */}
              <div className="w-[100px] h-[140px] flex-shrink-0 overflow-hidden rounded-lg">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>

              {/* Info */}
              <div className="flex flex-col justify-between min-w-0 flex-1">
                <div>
                  <div className="flex items-center gap-2 mb-1.5">
                    <span className="text-[10px] px-1.5 py-0.5 rounded bg-accent-100 text-accent-700 font-medium">
                      {comic.rating}
                    </span>
                    <span className={`text-[10px] px-1.5 py-0.5 rounded font-medium ${
                      comic.status === '连载中'
                        ? 'bg-primary-100 text-primary-700'
                        : 'bg-secondary-100 text-secondary-700'
                    }`}>
                      {comic.status}
                    </span>
                  </div>
                  <h3 className="font-heading text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                    {comic.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-1">{comic.author}</p>
                  <p className="text-xs text-foreground-400 mt-2 line-clamp-2 leading-relaxed">
                    {comic.description}
                  </p>
                </div>
                <div className="flex items-center gap-2 mt-3">
                  {comic.tags.map((tag) => (
                    <span key={tag} className="text-[10px] px-2 py-0.5 rounded-full bg-background-100 text-foreground-500">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}